import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

console.log("Supabase Connection Check:", {
  urlExists: !!supabaseUrl,
  keyExists: !!supabaseAnonKey,
  endpoint: supabaseUrl ? new URL(supabaseUrl).hostname : "none"
});

// Custom storage implementation to handle Remember Me logic
const customStorage = {
  getItem: (key) => {
    const rememberMe = localStorage.getItem("staff_remember_me") === "true";
    if (rememberMe) {
      return localStorage.getItem(key);
    }
    return sessionStorage.getItem(key);
  },
  setItem: (key, value) => {
    const rememberMe = localStorage.getItem("staff_remember_me") === "true";
    if (rememberMe) {
      localStorage.setItem(key, value);
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
      localStorage.removeItem(key);
    }
  },
  removeItem: (key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
};

// Singleton instance
let instance = null;

if (!window._supabaseClient) {
  if (supabaseUrl && supabaseAnonKey) {
    try {
      window._supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          storage: customStorage // Use our custom storage
        }
      });
      console.log("Supabase: Singleton initialized successfully.");
    } catch (e) {
      console.error("Supabase: Initialization error:", e);
    }
  }
}

export const supabase = window._supabaseClient;
export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);
